import React from "react";
import About from "../About";
import BackToTop from "../BackToTop";
import Blog from "../Blog";
import { BrandArea } from "../BrandArea";
import Choose from "../Choose";
import Fact from "../Fact";
import Footer from "../Footer";
import Header from "../Header";
import Portfolio from "../Portfolio";
import Service from "../Service";
import SliderArea from "../SliderArea";
import Testimonial from "../Testimonial";
import ScrollTop from "../seperate Components/ScrollToTop";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import CanadaHeader2 from "../seperate Components/CanadaHeader2";

const CanadaMain = () => {
  const navigate = useNavigate();
  const getData = async () => {
    const res = await axios.get("https://geolocation-db.com/json/");

    if (localStorage.getItem("load") == undefined) {
      if (localStorage.getItem("load") == undefined) {
        if (res.data.country_name == "India") {
          navigate('/')
        } else if (res.data.country_name == "United Kingdom") {
          window.location.assign('https://www.zithas.co.uk')
        }else {
          navigate('/')
        }
      }
      localStorage.setItem("load", true);
    }

    const timeout = setTimeout(() => {
      localStorage.removeItem("load");
    }, 7200000);

    return () => clearTimeout(timeout);
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <Helmet>
        <title>Get Expert Website Design and Development in USA</title>
        <meta
          name="description"
          content="Elevate your online presence with top-notch website development services in Canada. We're the trusted website development company for design and solutions."
        />
        <meta
          name="keywords"
          content="website development in canada, website design and development,
          website development company
        "
        />
      </Helmet>
      <ScrollTop />

      <CanadaHeader2 />
      <SliderArea />
      <Service />
      <About />
      <Fact />
      <Choose />
      <Portfolio />
      <Testimonial />
      <Blog />
      <BrandArea />
      <Footer />
    </div>
  );
};

export default CanadaMain;
